// import React, { Component } from "react";
// import NavbarFrontend from "components/Frontend/Navbar/NavbarFrontend";

// import FooterFrontend from "components/Frontend/Footer/FooterFrontend";
// import DetailsHeader from "components/Frontend/Content/DetailsHeader";

// export default class Home extends Component {
//   render() {
//     return (
//       <div>
//         <NavbarFrontend />
//         <DetailsHeader />
//         <FooterFrontend />
//       </div>
//     );
//   }
// }

import DefaultImage from "assets/frontend/DefaultImage";
import BreadcrumbFrontend from "components/Frontend/Breadcrumb/BreadcrumbFrontend";
import CardContentHome from "components/Frontend/Card/CardContentHome";
import React from "react";

function Detail() {
  return (
    <div>
      <div className="py-3 details-header">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="card">
                <div className="card-title">
                  <h3 className="container mt-4">Tutorial Laravel</h3>
                  <h5 className="container">Pengenalan Laravel</h5>
                </div>
                <div className="card-body">
                  <p>
                    <img src={DefaultImage} className="w-100" />
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Iste voluptates reiciendis sapiente, atque cum temporibus
                    nobis nostrum, sint quos aut recusandae voluptas quibusdam
                    voluptatibus. Quod porro quas tempore laborum quidem! Lorem
                    ipsum dolor sit amet consectetur adipisicing elit. Non
                    fugiat architecto quidem impedit cumque perferendis,
                    dignissimos earum hic dicta, temporibus quam voluptate
                    reiciendis tempore. Fugit sit assumenda quibusdam corrupti
                    ducimus?
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Iste voluptates reiciendis sapiente, atque cum temporibus
                    nobis nostrum, sint quos aut recusandae voluptas quibusdam
                    voluptatibus. Quod porro quas tempore laborum quidem! Lorem
                    ipsum dolor sit amet consectetur adipisicing elit. Non
                    fugiat architecto quidem impedit cumque perferendis,
                    dignissimos earum hic dicta, temporibus quam voluptate
                    reiciendis tempore. Fugit sit assumenda quibusdam corrupti
                    ducimus?
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 border-end">
              <ul className="list-group list-group-flush">
                <li className="list-group-item">Laravel</li>
                <li className="list-group-item">React Js & React native</li>
                <li className="list-group-item">Vue Js</li>
                <li className="list-group-item">Java</li>
                <li className="list-group-item">Flutter</li>
              </ul>
            </div>

            <div className="mt-2">
              <hr />
            </div>
            <CardContentHome />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Detail;
